import styled from "styled-components";

interface RadialChartStyleProps {
  $color: "yellow" | "green" | "blue" | undefined;
}

export const RadialChart = styled.div`
  position: relative;
  width: 100%;
  height: 110px;
  z-index: 10;
`;

export const RadialChartUnit = styled.div<RadialChartStyleProps>`
  position: absolute;
  display: flex;
  width: 80px;
  height: 80px;
  top: 15px;
  left: calc(50% - 40px);
  padding-top: 18px;
  color: ${(props) => props.theme.colors.tagBg};
  font-size: 1.2rem;
  background: ${(props) =>
    props.$color === "yellow"
      ? props.theme.colors.yellow20
      : props.$color === "green"
      ? props.theme.colors.green12
      : props.$color === "blue" && props.theme.colors.primary12};
  border-radius: 50%;
  justify-content: center;
  z-index: 9;
`;
